import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AnimeHeader from "../../component/AnimeHeader/index";
import "./style.scss";
function AnimeSearch() {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [searchParams] = useSearchParams();
  const itemsPerPage = 20;

  const searchTerm = searchParams.get("query") || "";

  useEffect(() => {
    const offset = (currentPage - 1) * itemsPerPage;

    let url = `https://kitsu.io/api/edge/anime?page[limit]=${itemsPerPage}&page[offset]=${offset}`;

    if (searchTerm.trim() !== "") {
      url = `https://kitsu.io/api/edge/anime?filter[text]=${encodeURIComponent(
        searchTerm
      )}&page[limit]=${itemsPerPage}&page[offset]=${offset}`;
    }

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
        setTotal(data.meta?.count || 0);
      })
      .catch((err) => console.error("Error:", err));
  }, [currentPage, searchTerm]);

  const totalPages = Math.ceil(total / itemsPerPage);

  return (
    <>
      
      <div className="search-anime">
        <AnimeHeader />
        <h2 className="search-title">
          Kết quả tìm kiếm: <strong>{searchTerm}</strong>
        </h2>

      <div className="kitsu-anime__grid">
        {data.map((anime) => (
          <Link to={`/anime/${anime.id}`} key={anime.id} className="link-anime">
            <div className="anime-card">
              <img
                className="anime-card__thumb"
                src={anime.attributes.posterImage.small}
                alt={anime.attributes.canonicalTitle}
              />
              <div className="anime-card__content">
                <h2 className="anime-card__name">
                  {anime.attributes.canonicalTitle}
                </h2>
                <p className="anime-card__synopsis">
                  {anime.attributes.synopsis}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="kitsu-anime__pagination">
        <button
          className="kitsu-anime__btn kitsu-anime__btn--prev"
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Quay lại 
        </button>
        <button
          className="kitsu-anime__btn kitsu-anime__btn--next"
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Tiếp theo
        </button>
      </div>
    </div>
    </>
  );
}

export default AnimeSearch;